<template>
  <div id="container">
    <v-card :class="{ card: true, mobile: isMobile }">
      <img
        class="clo"
        @click="closeDialog"
        :src="$vuetify.theme.dark?darkcloseIcon:closeIcon"
        alt=""
      />
      <div class="top">
        <h3 class="end" :class="{darkFont:$vuetify.theme.dark }">{{ $t("popupSoldoutEndsale") }}</h3>
        <h3 class="content" :class="{darkFont:$vuetify.theme.dark }" v-if="offsaleType != 'multi'">{{ parentValue.name }}</h3>
 
      </div>
      <div class="footer">
        <button
          class="sub v-btn uc"
          :class="{ 'sub-dis': isPay }"
          submit
          @click="subCommit"
        >
          {{ $t("popupTransferCommit") }}
        </button>
      </div>
    </v-card>
    <v-snackbar
      v-model="isShowFalse"
      color="error"
      centered
      timeout="2000"
      style="opacity: 0.8"
      ><span style="color: white; font-size: 20px">{{
        falseTitle
      }}</span></v-snackbar
    >
    <v-snackbar
      v-model="isShowSuccess"
      color="success"
      centered
      timeout="2000"
      style="opacity: 0.8"
      ><span style="color: white; font-size: 20px">{{
        successTitle
      }}</span></v-snackbar
    >
    <uComponents ref="ucom"></uComponents>
  </div>
</template>
<script>
import api from "@/api";
export default {
  data: () => ({
    newOpen: true,
    nftName: "",
    isShowFalse: false,
    isPay: false,
    isShowSuccess: false,
    falseTitle: "this is a error",
    successTitle: "create success",
    multiNFTids:[],
    closeIcon:require('@/assets/btn_close.png'),
         darkcloseIcon:require('@/assets/darkimage/btn_close1.png'),
  }),
  props: {
    address: {
      type: String,
    },
    name: {
      type: String,
    },
    onSaleTokenIds: {
      type: Array,
    },
    offSaleTokenIds: {
      type: Array,
    },
    offsaleType:{
       type: String,
    },
    parentValue: {
      type: Object
    },
    marketAddress:{
      type: String,
    }
  },
  computed: {
    isMobile: function () {
      return this.$vuetify.breakpoint.mobile;
    },
  },
  mounted() {

    console.log('wxl ---- parentValue 8888',this.parentValue);
    
    this.nftName = this.name;
     if(this.offSaleTokenIds &&this.offSaleTokenIds.length >0){
       for (let index = 0; index < this.offSaleTokenIds.length; index++) {
     this.multiNFTids+=this.offSaleTokenIds[index]+ ",";
     
   }
    this.multiNFTids = this.multiNFTids.substring(0, this.multiNFTids.lastIndexOf(','));
     }
      
  },
  methods: {
    async subCommit() {

          this.isPay = true
          if(this.parentValue.nftType == 'ERC1948'&& !this.parentValue.nftId){
            let params = {
  nftAddress:this.parentValue.nftAddress,
  serialNumber:this.parentValue.serialNumber,
 

}
         let result =  await api.home.productOffSale(params)

         if (result.success == true) {
          window.eventBus.$emit("collectionPay")
        this.$toast("success", this.$t("success"))
        this.$emit("getOpen", false);
        
      
      } else {
        this.isPay = false
        this.$toast("error", this.$t(result.msg));
      }
            
          }else{
            let res = await api.home.getFee();
        let result
       if (this.$chainName == "UPTICK EVM") {
         console.log('this.parentValue.marketAddress   0000000',this.parentValue.marketAddress);
         
         await this.$wallet.setContractAddress(this.parentValue.nftType, {
            address: this.parentValue.nftAddress,
            platformAddress: this.offsaleType == 'multi'? this.marketAddress : this.parentValue.marketAddress ,
          });
          // let vvv = this.parentValue;
          // console.log(vvv);
          if(this.offsaleType == 'multi'){
            result = await this.$wallet.offSaleBatch(
            this.parentValue.nftType,
            this.parentValue.nftAddress,
            this.offSaleTokenIds,
          );
          }else{
            result = await this.$wallet.offSale(
            this.parentValue.nftType,
            this.parentValue.nftAddress,
           this.parentValue.nftId,
          );
          }
          
          console.log("wxl ---- hash",result,this.parentValue);
       
        }
        if(!result.hash){
           this.isPay = false
           this.$toast("error",this.$t("requireFailed"))
           return
        }
      let param = {
        owner: this.$store.state.did,
        nftAddress: this.parentValue.nftAddress,
        nftId: this.offsaleType == 'multi'?  this.multiNFTids :this.parentValue.nftId,
        hash:result.hash,
        saleStatus:7
      };

    
      let nftDeList_res = await api.home.isDoing(param);

      if (nftDeList_res.success == true) {

        //  this.$toast("success", this.$t("success")).then(
        //     () => {
        //     this.$emit("getOpen", false);
        //   this.isPay = false;
        //    window.eventBus.$emit("collectionPay");
        //     }
        //   );
          let isShowTip = localStorage.getItem("isShowTip_"+this.$store.state.did)
        if(isShowTip == 'true'){
           this.$mtip({
              title: this.$t("endSaleSuccess"),
            });
        }
           
          this.$emit("getOpen", false);
          this.isPay = false;
           window.eventBus.$emit("collectionPay");
          
      
        } else {
          this.$toast("error", this.$t("transactionInprogressError"));
          this.isPay = false;
        }
        
      }

          },
      
          closeDialog() {
      this.open = false;
      this.$emit("getOpen", this.open);
    },
    },
   
  
};
</script>
<style lang="scss" scoped>
.card {
  display: flex;
  flex-direction: column;
  min-height: 180px;
  width: 600px;

  .top {
    display: flex;
    flex-direction: column;
    margin: 30px auto 0;

    .end {
      margin: 0 auto 13px;
      width: 100%;
      height: 21px;
      text-align: center;
      font-weight: bold!important;
      font-size: 25px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #270645;
      white-space: nowrap;
    }

    .content {
      margin: 19px auto 25px;
      width: 226px;
      min-height: 22px;
      font-family: Helvetica;
      font-size: 20px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #270645;
      text-align: center;
    }
    .nocontent {
      margin: 19px auto 25px;
      width: 226px;
      min-height: 22px;
      font-family: Helvetica;
      font-size: 20px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #270645;
      text-align: center;
    }
  }

  .clo {
    position: absolute;
    right: 10px;
    top: 10px;
    width: 30px;
    height: 31px;
    border-radius: 50%;
    margin-right: 0;
    cursor: pointer;
  }

  .footer {
    margin: 0 auto;

    .sub {
      margin: 30px auto;
      width: 450px;
      height: 51px;
      // background-image: linear-gradient(
      //     90deg,
      //     #d300fd 0%,
      //     #a439fe 26%,
      //     #7471ff 52%,
      //     #00fdcf 100%
      //   ),
      //   linear-gradient(#270645, #270645);
      background-blend-mode: normal, normal;
      border-radius: 25px;
      opacity: 0.9;
      font-weight: bold;;
      font-size: 20px;
      color: #ffffff;
    }
  }
  &.mobile {
    .footer {
      width: 100%;
      margin: 0;
      .sub {
        margin-left: 10%;
        width: 80%;
      }
    }
  }
}

img {
  display: inline-block;
  width: 126px;
  height: 126px;
  border-radius: 5px;
  margin: 1px 22px 10px 52px;
}
.sub-dis {
  position: relative;
  pointer-events: none;
  background-image: linear-gradient(#766983, #766983),
    linear-gradient(#270645, #270645) !important;
  background-blend-mode: normal, normal;
  border-radius: 25px;
  opacity: 0.9;
}
.sub-dis::after {
  content: "";
  background-image: url(../../assets/loading.gif);
  background-size: 100%;
  display: inline-block;
  position: absolute;
  width: 20px;
  height: 20px;
  margin-left: 110px;

  // box-shadow: 0 0 10px #fff;
  // border-radius: 50%;
}
</style>

